import React, { useState, useEffect, useContext } from "react";
import { ConfigContext } from "../../Context/ConfigContext";
import axios from "axios";
import { NavLink } from "react-router-dom";
import Swal from "sweetalert2";
import AccountSiderBar from "./AccountSideBar";
import { useTranslation } from "react-i18next";
import { OverlayLoader } from "../../Components/Shimmers";
import { axiosGet, axiosPost } from "../../Apis/axiosMethods";

const AccountDetails = () => {
  const { apiB2BURL, token } = useContext(ConfigContext);
  const [profileLoading, setProfileLoading] = useState(false);
  const [updateLoading, setUpdateLoading] = useState(false);

  const [userName, setUserName] = useState("");
  const [userEmail, setUserEmail] = useState("");
  const [loginId, setLoginId] = useState("");
  const [loginPassword, setLoginPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  const { t } = useTranslation();
  const dir = localStorage.getItem("dir");

  useEffect(() => {
    window.scrollTo(0, 0);
    GetCustomerInfo();
  }, []);

  const GetCustomerInfo = async () => {
    try {
      setProfileLoading(true);
      const business_user_id = localStorage.getItem("business_user_id");

      const response = await axiosGet(`/Users/GetUserInfo?business_user_id=${business_user_id}`);

      const data = response.data;
      if (data.success) {
        const info = data.data[0];
        setUserName(info.user_name);
        setUserEmail(info.user_email);
        setLoginId(info.login_id);
        setLoginPassword(info.login_password);
      } else {
        Swal.fire("Error!", data.message, "error");
      }
    } catch (error) {
      console.error("Error fetching customer info:", error);
    } finally {
      setProfileLoading(false);
    }
  };

  const UpdateProfile = async () => {
    try {
      const business_id = localStorage.getItem("business_id");
      const business_user_id = localStorage.getItem("business_user_id");

      const formData = {
        business_id,
        business_user_id,
        login_password: loginPassword,
        new_password: newPassword,
        confirm_password: confirmPassword,
      };

      const response = await axiosPost(`/Users/UpdateUserPassword`, formData);

      const data = response.data;
      if (data.success) {
        Swal.fire("Success", data.message, "success");
        window.location.reload()
      } else {
        Swal.fire("Error!", data.message, "error");
      }
    } catch (error) {
      Swal.fire("Error!", error.toString(), "error");
    } finally {
      setUpdateLoading(false);
    }
  };

  return (
    <>
      {
        profileLoading ?
          <div style={{ height: "70vh" }}>
            <OverlayLoader />
          </div>
          :
          <main dir={dir} style={{ textAlign: dir === "rtl" ? "right" : "unset", marginTop: "-10px" }}>
            <div className="page-header">
              <div className="container d-flex flex-column align-items-center">
                <nav aria-label="breadcrumb" className="breadcrumb-nav">
                  <div className="container">
                    <ol className="breadcrumb">
                      <li className="breadcrumb-item">
                        <NavLink to={"/"}>Home</NavLink>
                      </li>
                      <li className="breadcrumb-item">
                        <NavLink to={`/MyAccount`}>{t("my_account")}</NavLink>
                      </li>
                      <li className="breadcrumb-item active" aria-current="page">
                        {t("account_details")}
                      </li>
                    </ol>
                  </div>
                </nav>
                <h1>{t("account_details")}</h1>
              </div>
            </div>
            <div className="container account-container custom-account-container">
              <div className="row">
                <AccountSiderBar />
                <div className="col-lg-9 order-lg-last order-1 tab-content">
                  <div className="tab-pane fade show active" id="address" role="tabpanel">
                    <div className="order-content">
                      <h3 className="account-sub-title d-none d-md-block">
                        <i className="sicon-user align-middle mr-3" />
                        {t("account_details")}
                      </h3>
                      <div className="order-table-container">
                        <form>
                          <div className="form-group">
                            <label>{t("user_name")}</label>
                            <input
                              type="text"
                              className="form-control"
                              value={userName}
                              disabled
                            />
                          </div>
                          <div className="form-group">
                            <label>{t("user_email")}</label>
                            <input
                              type="email"
                              className="form-control"
                              value={userEmail}
                              disabled
                            />
                          </div>
                          <div className="form-group">
                            <label>{t("login_id")}</label>
                            <input
                              type="text"
                              className="form-control"
                              value={loginId}
                              disabled
                            />
                          </div>

                          <div className="change-password mt-4">
                            <h3 className="text-uppercase mb-2">
                              {t("password_change")}
                            </h3>
                            <div className="form-group">
                              <label>{t("current_password")}</label>
                              <input
                                type="password"
                                className="form-control"
                                value={loginPassword}
                                onChange={(e) => setLoginPassword(e.target.value)}
                              />
                            </div>
                            <div className="form-group">
                              <label>{t("new_password")}</label>
                              <input
                                type="password"
                                className="form-control"
                                value={newPassword}
                                onChange={(e) => setNewPassword(e.target.value)}
                              />
                            </div>
                            <div className="form-group">
                              <label>{t("confirm_new_password")}</label>
                              <input
                                type="password"
                                className="form-control"
                                value={confirmPassword}
                                onChange={(e) => setConfirmPassword(e.target.value)}
                              />
                            </div>
                          </div>

                          <div className="form-footer mt-3 mb-0">
                            {updateLoading ? (
                              <button type="button" className="btn btn-default mr-0">
                                {t("save_changes")}...
                              </button>
                            ) : (
                              <button
                                type="button"
                                onClick={() => {
                                  setUpdateLoading(true);
                                  UpdateProfile();
                                }}
                                className="btn btn-primary mr-0"
                              >
                                {t("save_changes")}
                              </button>
                            )}
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </main>
      }
    </>
  );
};

export default AccountDetails;
